import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IHesapHareketleri } from '@models/dashboard';
import { DashboardService } from '@services/apis/dashboard.service';
import { map, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-activities-list',
  templateUrl: './activities-list.component.html',
  styleUrls: ['./activities-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ActivitiesListComponent implements OnInit {
  public chartData = [30, 45, 32, 70, 40, 40, 40];
  public chartCategory = ['Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar', 'Pazartesi'];
  public totalBalance = 437654;
  public hesapHareketleri: IHesapHareketleri[];
  public tumHesapHareketleri: IHesapHareketleri[];
  public hesapDurumuTemp: IHesapHareketleri[];
  public hesapDurumuToplam: number;
  public hesapTurId: number;

  constructor(
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
  ) { }

  ngOnInit(): void {
    this.route.params.pipe(
      map(param => Number(param.hesapTurId)),
      tap((hesapTurID: number) => {
        this.hesapTurId = hesapTurID;
      }),
      switchMap(() => this.getHesapHareketleri())
    ).subscribe(() => { });
  }

  getHesapHareketleri() {
    return this.dashboardService.getHesapHareketleri$().pipe(
      tap(response => {
        this.tumHesapHareketleri = response;
        this.getHesapHareketleriByTurId(this.hesapTurId);
      }));
  }

  getHesapHareketleriByTurId(hesapTurId: number) {
    this.hesapHareketleri = this.tumHesapHareketleri.filter((x) => x.hesapTurId === hesapTurId);
  }

  getTotal() {
    this.hesapDurumuToplam = this.hesapDurumuTemp
      .map((hesap) => hesap.bakiye)
      .reduce((acc, next) => {
        return acc + next;
      }, 0);
  }

}
